import React from "react";
import {
  Layout,
  Typography,
  Row,
  Col,
  Button,
  Card,
  Breadcrumb,
  Divider,
  Image,
  Carousel,
} from "antd";
import { NavLink } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import img from "../../assets/11.jpg";
import img1 from "../../assets/esg-1.png";
import img2 from "../../assets/esg-2.png";
import img3 from "../../assets/esg-3.png";
import img4 from "../../assets/esg-4.png";

import s from "./styles.module.css";
import { Fade } from "react-awesome-reveal";
import { SendButton } from "../../components/SendButton";

const { Header, Content } = Layout;
const { Title, Paragraph } = Typography;

export const Esg = () => {
  return (
    <Layout>
      <Row
        style={{
          position: "absolute",
          maxWidth: "1440px",
          top: "80px",
          margin: "0 auto",
          padding: "0 20px",
          zIndex: 100,
          right: 0,
          left: 0,
        }}
      >
        <Col>
          <Title className={s["esg-title"]}>
            ESG (Environmental, Social, Governance)
          </Title>
          <Breadcrumb
            items={[
              {
                title: (
                  <NavLink to={"/"}>
                    <ArrowLeftOutlined style={{ marginRight: "5px" }} />
                    Back to main
                  </NavLink>
                ),
              },
            ]}
          />
        </Col>
      </Row>
      <Carousel effect={"fade"}>
        <div className={s["main-carusel-wrapper"]}>
          <img src={img} className="responsive-image" alt="Esg" />
          <Content
            style={{ padding: "24px", maxWidth: "1440px", margin: "0 auto" }}
          >
            <Row className={s["main-carusel-row"]}>
              <Col xs={24} md={12} style={{ zIndex: 2 }}>
                <div className={s["main-carusel-title"]}>
                  Drive Sustainable Growth with Strategic ESG Consulting
                </div>
                <Paragraph className={s["main-carusel-description"]}>
                  In today’s business world, success is measured by more than
                  financial performance. Environmental, Social, and Governance
                  (ESG) factors are now critical to building a responsible,
                  resilient, and forward-thinking business. We provide tailored
                  ESG consulting services to help companies like yours thrive in
                  this new era of accountability and purpose-driven leadership.
                </Paragraph>
              </Col>
            </Row>
          </Content>
        </div>
      </Carousel>
      <Divider />
      <Content
        style={{ padding: "24px", maxWidth: "1440px", margin: "0 auto" }}
      >
        {" "}
        <Fade cascade triggerOnce damping={0.1}>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Card className={s["esg-card"]}>
                <Image src={img1} preview={false} />
                <Title level={3}>Transform Challenges into Opportunities</Title>
                <Paragraph>
                  Navigating the complexities of ESG can be challenging, but it
                  also presents tremendous opportunities for growth. Our team
                  works closely with your leadership to identify the most
                  material ESG factors for your business and industry. Whether
                  reducing your environmental footprint, improving diversity and
                  inclusion, or enhancing corporate governance, we help you turn
                  challenges into powerful drivers of long-term success.
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card className={s["esg-card"]}>
                <Image src={img2} preview={false} />
                <Title level={3}>
                  Custom ESG Strategies for Meaningful Impact
                </Title>
                <Paragraph>
                  No companies are the same; your ESG strategy shouldn’t be
                  either. We craft custom ESG frameworks that align with your
                  business goals and stakeholder expectations. Our approach goes
                  beyond simply meeting compliance standards—we design
                  strategies that create real, measurable impact, fostering
                  trust with investors, employees, and customers alike.
                </Paragraph>
              </Card>
            </Col>
          </Row>
          <Divider />

          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Card className={s["esg-card"]}>
                <Image src={img3} preview={false} />
                <Title level={3}>
                  Stay Ahead of the Curve with Expert Guidance
                </Title>
                <Paragraph>
                  The ESG landscape is evolving rapidly. With increasing
                  regulatory pressures, shifting consumer demands, and growing
                  investor scrutiny, staying ahead requires specialized
                  expertise. We provide the guidance and insights you need to
                  navigate this complex terrain. Our consultants offer deep
                  knowledge of global ESG trends, helping you anticipate
                  challenges and capitalize on emerging opportunities.
                </Paragraph>
              </Card>
            </Col>

            <Col xs={24} md={12}>
              <Card className={s["esg-card"]}>
                <Image src={img4} preview={false} />
                <Title level={3}>Build a Resilient, Responsible Business</Title>
                <Paragraph>
                  Supercharge your company with a robust ESG strategy that
                  drives value and strengthens your brand. From sustainability
                  initiatives to social responsibility programs, we empower you
                  to make choices that benefit your business and the world. Get
                  in touch with us today to begin your journey toward
                  responsible, sustainable growth.
                </Paragraph>
              </Card>
            </Col>
          </Row>
          <Divider />

          <Row justify="center" className={s["esg-footer"]}>
            <Col>
              <SendButton
                type="primary"
                size="large"
                className={s["esg-button"]}
              >
                Get in Touch
              </SendButton>
            </Col>
          </Row>
        </Fade>
      </Content>
    </Layout>
  );
};
